module.exports = __webpack_public_path__ + "img/teacher_comment.8372fb7f.svg";